import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlusRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M17.2 6a1.2 1.2 0 1 0-2.4 0v8.8H6a1.2 1.2 0 1 0 0 2.4h8.8V26a1.2 1.2 0 1 0 2.4 0v-8.8H26a1.2 1.2 0 1 0 0-2.4h-8.8z" })
});
export default SvgPlusRegularIcon;
